/**
 * @file DetailsPanel.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component of master settings to manage course details
 */
import React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  Skeleton,
  Divider,
} from "@mui/material";
import { TabPanel } from "./TabPanel";

export const DetailsPanel = ({
  isLoading,
  languageList,
  documentList,
  value,
  handleChange,
  selectedCourse,
  selectedCountry,
  handleViewDetails,
  newLanguage,
  setNewLanguages,
  newDocuments,
  setNewDocuments,
  installments,
  setInstallments,
  lifecycleEvents,
}) => {
  return (
    <Box
      flex={1}
      height="100%"
      borderRadius="12px"
      px="8px"
      py={1}
      bgcolor="#F7F7F7"
      display="flex"
      flexDirection="column"
    >
      <Stack
        pb={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        {isLoading ? (
          <Skeleton variant="rounded" width={140} height={24} />
        ) : (
          <Typography fontWeight={500} fontSize={20} color="#222222">
            Details{" "}
            {selectedCourse?.coursename && `- ${selectedCourse.coursename}`}
          </Typography>
        )}
        {isLoading ? (
          <Skeleton variant="rounded" width={160} height={40} />
        ) : (
          <Button
            variant="outlined"
            sx={{ borderRadius: "12px" }}
            onClick={handleViewDetails}
          >
            View {value === 0 ? "Language" : "Documents"}
          </Button>
        )}
      </Stack>
      <Divider />
      <Stack direction="row" height="100%" minHeight={400} display="flex">
        <TabPanel
          languages={languageList}
          documents={documentList}
          value={value}
          selectedCourse={selectedCourse}
          selectedCountry={selectedCountry}
          handleChange={handleChange}
          isLoading={isLoading}
          newLanguage={newLanguage}
          setNewLanguages={setNewLanguages}
          newDocuments={newDocuments}
          setNewDocuments={setNewDocuments}
          installments={installments}
          setInstallments={setInstallments}
          lifecycleEvents={lifecycleEvents}
        />
      </Stack>
    </Box>
  );
};
